

















































































































































































































































































































































































































































































































































import {
  getSelectCourseList,
  getSelectClassList,
  staffList,
  searchStudent,
} from "@/api/globalSearch";
import {
  getExperienceLessonListData,
  getExperienceLessonListApi,
  experienceListExport,
} from "@/api/experienceLesson";
import { PageModule } from "@/store/module/page";
import feedbackDialog from "./feedbackDialog.vue";
import cancelDialog from "./cancelDialog.vue";
import { dateFormat } from "@/utils/timeFormat";
import { Vue, Component, Mixins } from "vue-property-decorator";
import { exportLoop } from "@/utils/export";
import { mixin } from "@/mixin/tabPageInfoMixin";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "experienceLogList",
  components: {
    feedbackDialog,
    cancelDialog,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
})
export default class extends Mixins(mixin) {
  searchInfo: any = {
    teacher_id: "",
    teacher_list: [],
    follow_staff_id: "",
    follow_staff_list: [],
  };
  teacherList: any[] = [];
  courseList: any[] = [];
  sourceChannelList: any[] = [];
  classList: any[] = [];
  staffList: any[] = [];
  studentList: any[] = [];
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  showFormSearch = false;
  studentAppearLabelList: any[] = [];
  created() {
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
    }).then((res) => {
      this.studentAppearLabelList = res.data.list;
    });
    const self = this;
    self.searchInfo.date = [
      dateFormat("YYYY-mm-dd", new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
      dateFormat("YYYY-mm-dd", new Date().getTime() + 30 * 24 * 60 * 60 * 1000),
    ];
    self.mixinGetPageInfo("experienceRecordSearch");
    if (
      PageModule.latestRoute === "studyDetails" ||
      PageModule.latestRoute === "experienceSechdule"
    ) {
      const cache = PageModule.pageInfo.recruitExperienceList;
      if (cache.page) {
        self.page = cache.page;
      }
      if (cache.search_info) {
        self.searchInfo = cache.search_info;
      }
    } else if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      const params = self.$route.params;
      if (params.start_date && params.end_date) {
        self.searchInfo.date = [params.start_date, params.end_date];
      }
      if (params.experience_status) {
        self.searchInfo.experience_status = JSON.parse(
          params.experience_status
        );
      }
    } else {
      if (self.$route.query.from === "salary_tab_achievements") {
        const salaryCache = sessionStorage.getItem(
          "salary-achievements-link-to-experience-student-list"
        );
        if (salaryCache) {
          // 来自工资绩效页
          const cache: {
            teacher_id?: number;
            teacher_name?: string;
            lesson_date?: string[];
            experience_statu?: number;
          } = JSON.parse(salaryCache);
          if (cache.teacher_id && cache.teacher_name) {
            self.searchInfo.teacher_id = cache.teacher_id;
            self.searchInfo.teacher_name = cache.teacher_name; // 给筛选组件设置初始值
          }
          if (cache.lesson_date) {
            self.searchInfo.date = cache.lesson_date;
          }
          if (cache.experience_statu) {
            self.searchInfo.experience_status = [cache.experience_statu];
          }
          sessionStorage.removeItem(
            "salary-achievements-link-to-experience-student-list"
          );
        }
      }
    }
    // 来自体验数
    if (self.$route.query.from === "experience") {
      self.searchInfo.date[0] = self.$route.query.s_time;
      self.searchInfo.date[1] = self.$route.query.e_time;
      if (self.$route.query.c_id) {
        self.searchInfo.follow_staff_id = Number(self.$route.query.c_id);
      }
      if (self.$route.query.s_id) {
        self.searchInfo.teacher_id = Number(self.$route.query.s_id);
      }
      if (self.$route.query.source_id) {
        self.searchInfo.source_channel = Number(self.$route.query.source_id);
        sourceTypeSelectListApi().then((result: any) => {
          let target = result.data.list.find((s: any) => {
            return s.source_id === Number(self.$route.query.source_id);
          });
          if (target) {
            this.sourceChannelList = [target];
          }
        });
      }
      if (self.$route.query.course_id) {
        self.searchInfo.course_id =
          Number(self.$route.query.course_id) === 0
            ? ""
            : Number(self.$route.query.course_id);
      }
      if (self.$route.query.a_id) {
        self.searchInfo.appear_id = Number(self.$route.query.a_id);
      }
      if (self.$route.query.val === "finish_count") {
        self.searchInfo.experience_status = [2];
      }
      if (self.$route.query.val === "invited_count") {
        self.searchInfo.experience_status = [1, 2, 3];
      }
      if (self.$route.query.val === "invited_count_1vn") {
        self.searchInfo.experience_status = [1, 2, 3];
        self.searchInfo.course_type = 1;
      }
      if (self.$route.query.val === "invited_count_1v1") {
        self.searchInfo.experience_status = [1, 2, 3];
        self.searchInfo.course_type = 2;
      }
      if (
        self.$route.query.val === "transform_count" ||
        self.$route.query.val === "transform_amount"
      ) {
        self.searchInfo.pay_status = 2;
      }
      if (self.$route.query.val === "transform_amount_1vn") {
        self.searchInfo.course_type = 1;
        self.searchInfo.pay_status = 2;
      }
      if (self.$route.query.val === "transform_amount_1v1") {
        self.searchInfo.course_type = 2;
        self.searchInfo.pay_status = 2;
      }
      // 体验转化数
      if (self.$route.query.val === "all") {
        self.searchInfo.experience_status = [2];
        self.searchInfo.pay_status = 2;
      }
      if (self.$route.query.pay_type) {
        self.searchInfo.pay_status = Number(self.$route.query.pay_type);
      }
    }
    self.getList({
      page: self.page,
      page_size: self.pageSize,
    });
    searchStudent({
      page: 1,
      page_size: 50,
      status: [1, 2],
    }).then((result: any) => {
      if (result.error_code === 0) {
        self.studentList = result.data.list;
        getSelectCourseList({
          page: 1,
          page_size: 100,
        }).then((res: any) => {
          self.courseList = res.data.list;
        });
        getSelectClassList({
          page: 1,
          page_size: 50,
        }).then((res: any) => {
          self.classList = res.data.list;
        });
        staffList({
          page: 1,
          page_size: 50,
          job_ids: [3],
        }).then((res: any) => {
          // 处理来自体验数据且没有这个课程顾问的情况下添加一条课程顾问;
          if (self.$route.query.experience_course) {
            let hasStaffList = false;
            res.data.list.map((it: any) => {
              if (
                self.$route.query.from === "experience" &&
                it.staff_id !== Number(self.$route.query.c_id)
              ) {
                hasStaffList = true;
              } else {
                hasStaffList = false;
              }
            });
            if (hasStaffList) {
              res.data.list.unshift({
                name: self.$route.query.c_name,
                staff_id: Number(self.$route.query.c_id),
              });
            }
          }
          self.staffList = res.data.list;
        });
        staffList({
          page: 1,
          page_size: 50,
          job_ids: [1],
        }).then((res: any) => {
          self.teacherList = res.data.list;
        });
      }
    });
    this.handleSearchSource();
  }
  handleSearchSource() {
    if (!this.searchInfo.appear_id) {
      return false;
    }
    sourceTypeSelectListApi({ appear_id: this.searchInfo.appear_id }).then(
      (result: any) => {
        this.sourceChannelList = result.data.list;
      }
    );
  }
  handleAppear(scope: any) {
    let target = this.studentAppearLabelList.find((item: any) => {
      return scope.row.appear_id === item.id;
    });
    if (target) {
      return target.name;
    } else {
      return "-";
    }
  }
  resetSearch() {
    this.searchInfo = {
      experience_status: [],
      time_tag: -1,
      pay_status: -1,
      course_type: -1,
    };
    this.handleSearch();
    this.mixinSavePageInfo("experienceRecordSearch");
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
    this.mixinSavePageInfo("experienceRecordSearch");
  }
  handleRefresh() {
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  handleSearchStudent(v: any) {
    searchStudent({
      page: 1,
      page_size: 50,
      key_word: v,
      status: [1, 2],
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.studentList = res.data.list;
      }
    });
  }
  handleSearchCourse(v: string) {
    if (!v) {
      return false;
    }
    getSelectCourseList({
      page: 1,
      page_size: 100,
      title: v,
    }).then((res: any) => {
      this.courseList = res.data.list;
    });
  }
  handleSearchClass(v: any) {
    getSelectClassList({
      page: 1,
      page_size: 50,
      name: v,
    }).then((res: any) => {
      this.classList = res.data.list;
    });
  }
  clickexport() {
    const data: any = {};
    if (this.searchInfo.student_id !== "") {
      data.student_id = this.searchInfo.student_id;
    }
    if (this.searchInfo.teacher_id !== "") {
      data.teacher_id = this.searchInfo.teacher_id;
    }
    if (this.searchInfo.course_id !== "") {
      data.course_id = this.searchInfo.course_id;
    }
    if (this.searchInfo.class_id !== "") {
      data.class_id = this.searchInfo.class_id;
    }
    if (this.searchInfo.follow_staff_id !== "") {
      data.follow_staff_id = this.searchInfo.follow_staff_id;
    }
    if (this.searchInfo.date && this.searchInfo.date.length === 2) {
      data.start_date = this.searchInfo.date[0];
      data.end_date = this.searchInfo.date[1];
    } else {
      data.start_date = dateFormat("YYYY-mm-dd", new Date());
      data.end_date = dateFormat("YYYY-mm-dd", new Date());
    }
    if (this.searchInfo.experience_status.length > 0) {
      data.experience_status_arr = this.searchInfo.experience_status;
    }
    if (this.searchInfo.pay_status >= 0) {
      data.pay_status = this.searchInfo.pay_status;
    }
    if (this.searchInfo.source_channel !== "") {
      data.source_type = this.searchInfo.source_channel;
    }
    if (this.searchInfo.appear_id !== "") {
      data.appear_id = this.searchInfo.appear_id;
    }
    if (this.searchInfo.time_tag != -1) {
      data.time_tag = this.searchInfo.time_tag;
    }
    if (this.searchInfo.order_no !== "") {
      data.order_no = this.searchInfo.order_no;
    }
    experienceListExport(data).then((res: any) => {
      if (res.error_code === 0) {
        exportLoop(res.data.task_id);
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  getList(params: { page: number; page_size: number }) {
    const option: getExperienceLessonListData = {
      page: params.page,
      page_size: params.page_size,
      start_date: "",
      end_date: "",
    };
    if (this.searchInfo.student_id !== "") {
      option.student_id = this.searchInfo.student_id;
    }
    if (this.searchInfo.teacher_id !== "") {
      option.teacher_id = this.searchInfo.teacher_id;
    }
    if (this.searchInfo.course_id !== "") {
      option.course_id = this.searchInfo.course_id;
    }
    if (this.searchInfo.class_id !== "") {
      option.class_id = this.searchInfo.class_id;
    }
    if (this.searchInfo.follow_staff_id !== "") {
      option.follow_staff_id = this.searchInfo.follow_staff_id;
    }
    if (this.searchInfo.date && this.searchInfo.date.length === 2) {
      option.start_date = this.searchInfo.date[0];
      option.end_date = this.searchInfo.date[1];
    }
    // else {
    //   option.start_date = dateFormat("YYYY-mm-dd", new Date());
    //   option.end_date = dateFormat("YYYY-mm-dd", new Date());
    // }
    if (this.searchInfo.experience_status.length > 0) {
      option.experience_status_arr = this.searchInfo.experience_status;
    }
    if (this.searchInfo.pay_status >= 0) {
      option.pay_status = this.searchInfo.pay_status;
    }
    if (this.searchInfo.source_channel !== "") {
      option.source_type = this.searchInfo.source_channel;
    }
    if (this.searchInfo.appear_id !== "") {
      option.appear_id = this.searchInfo.appear_id;
    }
    if (this.searchInfo.time_tag != -1) {
      option.time_tag = this.searchInfo.time_tag;
    }
    if (this.searchInfo.order_no !== "") {
      option.order_no = this.searchInfo.order_no;
    }
    if (this.searchInfo.course_type > 0) {
      option.course_type = this.searchInfo.course_type;
    }
    getExperienceLessonListApi(option).then((res: any) => {
      this.page = res.data.page;
      this.total = res.data.total;
      res.data.list.map((item: any) => {
        item.date_format = `${item.experience_date} （周${
          ["日", "一", "二", "三", "四", "五", "六"][item.experience_week]
        }） ${item.experience_start_time.slice(
          0,
          5
        )} ~ ${item.experience_end_time.slice(0, 5)}`;
        if (item.transform_day === 0) {
          item.transform_day = "-";
        }
      });
      this.tableData = res.data.list;
    });
  }
  toStudentDetail(row: any) {
    this.mixinSavePageInfo("experienceRecordSearch");
    this.$router.push({
      name: "studyDetails",
      query: {
        id: row.student.student_id,
      },
    });
  }
  toCreateSechdule(row: any) {
    if (row.student) {
      PageModule.SET_PAGE_INFO({
        name: "recruitExperienceList",
        key: "selected_student",
        value: row.student,
      });
    }
    PageModule.SET_PAGE_INFO({
      name: "recruitExperienceList",
      key: "search_info",
      value: { ...this.searchInfo },
    });
    this.$router.push({
      name: "experienceSechdule",
      query: {
        sid: row.student.student_id,
        sname: row.student.name,
      },
    });
  }
  goCreateSechdule() {
    this.$router.push({
      name: "experienceSechdule",
      query: {
        show_follow_dialog_id: "99",
      },
    });
    this.mixinSavePageInfo("experienceRecordSearch");
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
    this.mixinSavePageInfo("experienceRecordSearch");
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  // 去订单详情
  toOrderDetails(it: any) {
    this.mixinSavePageInfo("experienceRecordSearch");
    if (it.order_amount !== "") {
      this.$router.push({
        name: "orderManageDetail",
        query: {
          sid: it.student.student_id,
          id: it.order_id,
        },
      });
    }
  }
}
